export function waitInMilliSeconds(timeInMs) {
  return new Promise(res => {
    setTimeout(() => res(), timeInMs)
  })
}
